import { authRequest } from '@/lib/deep-mining/request';

export interface AccessKeyInfo {
  id: string;
  api_key: string;
  space_id: string;
  space_name?: string;
  name?: string;
  metadata?: Record<string, any>;
  created_at: string;
}

/** 获取当前空间的 Access Key（不存在则自动创建） */
export const getOrCreateAccessKey = async (): Promise<AccessKeyInfo> => {
  return authRequest('/auth/access-key', {
    method: 'GET',
  });
};

/** 重置当前空间的 Access Key */
export const refreshAccessKey = async (
  keyId: string,
): Promise<AccessKeyInfo> => {
  return authRequest(`/auth/access-key/refresh?key_id=${keyId}`, {
    method: 'GET',
  });
};
